import { gql } from '@apollo/client';

/* ── stock alpha platform operations ────────────────────────── */

/**
 * The desk's writes. Each is role-gated on the server — thesis review is an
 * employee's, publishing is compliance's, alerts are a research analyst's,
 * halting a paper book is the research lead's — so a seat without the role
 * gets a refusal, which the screen shows as such.
 */

/** decision: analyst_approve | compliance_approve | reject. */
export const REVIEW_ALPHA_THESIS = gql`
  mutation ReviewAlphaThesis($thesisId: Int!, $decision: String!, $note: String) {
    reviewAlphaThesis(thesisId: $thesisId, decision: $decision, note: $note) { id status }
  }
`;

export const PUBLISH_ALPHA_THESIS = gql`
  mutation PublishAlphaThesis($thesisId: Int!) {
    publishAlphaThesis(thesisId: $thesisId) { id status publishedAt }
  }
`;

export const ACKNOWLEDGE_ALPHA_ALERT = gql`
  mutation AcknowledgeAlphaAlert($alertId: Int!) {
    acknowledgeAlphaAlert(alertId: $alertId) { id status acknowledgedBy acknowledgedAt }
  }
`;

export const RESOLVE_ALPHA_ALERT = gql`
  mutation ResolveAlphaAlert($alertId: Int!, $note: String) {
    resolveAlphaAlert(alertId: $alertId, note: $note) { id status resolvedBy resolvedAt }
  }
`;

export const HALT_ALPHA_PAPER_BOOK = gql`
  mutation HaltAlphaPaperBook($portfolioId: String!, $reason: String!) {
    haltAlphaPaperPortfolio(portfolioId: $portfolioId, reason: $reason) { portfolioId status haltedOn haltReason }
  }
`;

export const RESUME_ALPHA_PAPER_BOOK = gql`
  mutation ResumeAlphaPaperBook($portfolioId: String!) {
    resumeAlphaPaperPortfolio(portfolioId: $portfolioId) { portfolioId status haltedOn haltReason }
  }
`;

/**
 * Generate a company's initiating-coverage report (markdown and PDF). Runs in
 * the background on the server and answers at once; the new report appears
 * in `alphaCompanyReports` when it is done. Research analyst only.
 */
export const GENERATE_COMPANY_REPORT = gql`
  mutation GenerateCompanyReport($securitySymbol: String!) {
    generateCompanyReport(securitySymbol: $securitySymbol) { started job message }
  }
`;

/**
 * Bring the stock alpha data to a date: computes the day's factors, scores
 * the active models and runs the persona screens (the `alpha.daily` job).
 * Runs in the background on the server and answers at once; the new date
 * appears in `alphaRankings` when it is done. Research analyst only.
 */
export const RUN_ALPHA_SCORING = gql`
  mutation RunAlphaScoring($asOfDate: Date) {
    runAlphaScoring(asOfDate: $asOfDate) { started job message }
  }
`;
